module.exports = __webpack_public_path__ + "static/user-research-number-2-2d22ae6a3e25570b15880123134250ab.png";